<div class="flex h-full">
    <div style="padding: 16px" class="flex flex-col flex-auto items-center" [ngClass]="{ 'justify-center': !showErrorDetails() }">
        <div style="margin-bottom: 16px">
            <h1 class="title big" style="margin-bottom: 0px">Error</h1>
            <h1 class="sub-title medium">Oeps.. Er is iets fout gegaan</h1>
            <p>We werken eraan. Kom later terug.</p>
            <button mat-stroked-button (click)="onGoHomeButtonClick()">Ga naar Home</button>
        </div>

        @let result = exceptionView();
        @if (result && showErrorDetails()) {
            <table class="rax-table">
                <tbody>
                    <tr>
                        <td colspan="2"><h3>Result</h3></td>
                    </tr>
                    <tr>
                        <td>Success:</td>
                        <td>{{ result.success }}</td>
                    </tr>
                    <tr>
                        <td>Reason:</td>
                        <td style="word-break: break-word">{{ result.reason }}</td>
                    </tr>
                    @if (result.isException) {
                        <tr>
                            <td>Is exception:</td>
                            <td style="word-break: break-word">{{ result.isException }}</td>
                        </tr>
                    }
                    @if (result.exceptionData; as exceptionData) {
                        <tr>
                            <td colspan="2"><h3>Exception Details:</h3></td>
                        </tr>
                        @if (exceptionData.exceptionType) {
                            <tr>
                                <th>Exception Type:</th>
                                <td style="word-break: break-word">{{ exceptionData.exceptionType }}</td>
                            </tr>
                        }
                        <!--@if(exceptionView.exceptionData.path) {
                            <tr>
                                <th>Path:</th>
                                <td>{{exceptionData.path}}</td>
                            </tr>
                        }-->
                        @if (exceptionData.message) {
                            <tr>
                                <th>Message:</th>
                                <td style="word-break: break-word">{{ exceptionData.message }}</td>
                            </tr>
                        }
                        @if (exceptionData.source) {
                            <tr>
                                <th>Source:</th>
                                <td style="word-break: break-word">{{ exceptionData.source }}</td>
                            </tr>
                        }
                        @if (exceptionData.stack) {
                            <tr>
                                <th>Stack:</th>
                                <td style="word-break: break-word">{{ exceptionData.stack }}</td>
                            </tr>
                        }
                    }
                </tbody>
            </table>
        }
    </div>
</div>

<div style="position: fixed; right: 0; bottom: 0">
    <button mat-raised-button (click)="onToggleShowErrorDetailsButtonClick()" style="width: 100px">
        {{ showErrorDetails() ? 'Minder' : 'Meer' }}
    </button>
</div>
